module.exports = __webpack_public_path__ + "img/pr-11.8cd88b89.png";